/**
 * @Description: 标签边框分类信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  LabelFrameCategoryModel,
  LabelFrameCategorySearchModel,
  LabelFrameCategoryPageSearchModel,
  LabelFrameCategoryAddModel,
  LabelFrameCategoryUpdateModel,
  LabelFrameCategoryUpdateOrderListModel,
  IdsModel
} from '@/model/product/LabelFrameCategoryModel'

const baseUrl = Route.product + '/labelFrameCategory'

/**
 * 搜索分页数据
 */
export const pageSearchLabelFrameCategory = (param: LabelFrameCategoryPageSearchModel) => {
  return https().request<RootObject<PageRespModel<LabelFrameCategoryModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchLabelFrameCategory = (param: LabelFrameCategorySearchModel) => {
  return https().request<RootObject<LabelFrameCategoryModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getLabelFrameCategory = (id: number) => {
  return https().request<RootObject<LabelFrameCategoryModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addLabelFrameCategory = (param: LabelFrameCategoryAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateLabelFrameCategory = (param: LabelFrameCategoryUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据排序
 */
export const updateLabelFrameCategoryOrder = (param: LabelFrameCategoryUpdateOrderListModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update/order'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeLabelFrameCategory = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveLabelFrameCategory = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
